import {i18n} from '@/setup/i18n-setup';
import {IFeeType, IStatus} from "@/constants/interface";

const moment = require('moment');

export function yearsOptions(state) {
  return state.years.map(res => {
    return {...res, label: res.label}
  })
}

export function yearLast5Options(state) {
  return state.years.filter(res => res.value >= parseInt(moment().format("YYYY")) - 5).map(res => {
    return {...res, label: res.label}
  })
}

export function monthsOptions(state) {
  return state.months.map(res => {
    return {...res, label: `${res.value}. ${res.label}`}
  })
}

export function monthsNoNumOptions(state) {
  return state.months.map(res => {
    return {...res, label: `${res.label}`}
  })
}

export function monthsOptionsExecutive(state) {
  let monthsOptions = state.months.map(res => {
    return {...res, label: `${res.value}. ${res.label}`}
  })
  if (state.years.find(res => res.selected).value === parseInt(moment().format("YYYY"))) {
    monthsOptions = state.months.filter(res => {
      let limit = parseInt(moment().format("M"))
      if (parseInt(moment().format("D")) <= 5) {
        limit = limit - 1
      }
      return res.value < limit
    }).map(res => {
      return {...res, label: `${res.value}. ${res.label}`}
    })
  }
  return monthsOptions
}

export function statusesOptions(state) {
  return state.statuses.map(res => {
    return {...res, label: res.value} //i18n.t('getters.statusesOptions')[res.value]
  })
}

export function contractStatusesOptions(state) {
  return state.contractStatuses
    .filter(res => ['Approved', 'Npl'].includes(res.value))
    .map(res => {
      return {...res, label: i18n.t('getters.contractStatusesOptions')[res.value]}
    })
}

export function contractStatusesProsecutionOptions(state) {
  return state.contractStatuses
    .filter(res => ['Approved', 'NplReturn', 'Close'].includes(res.value))
    .map(res => {
      return {...res, label: i18n.t('getters.contractStatusesOptions')[res.value]}
    })
}

export function educationStatusesOptions(state) {
  return state.educationStatuses.map(res => {
    return {...res, label: i18n.t('getters.educationStatusesOptions')[res.value]}
  })
}

export function actionTypesOptions(state) {
  const actionTypesOptions = state.actionTypes
    .filter(res => res.value !== 'OutstandingBalance')
    .map(res => {
      return {...res, label: i18n.t('getters.actionTypesOptions')[res.value]}
    })

  return actionTypesOptions || []
}

export function transactionTypesOptions(state) {
  const transactionTypesOptions = state.transactionTypes
    .map(res => {
      return {...res, label: i18n.t('getters.transactionTypesOptions')[res.value]}
    })

  return transactionTypesOptions || []
}

export function transactionDisplaysOptions(state) {
  const transactionDisplaysOptions = state.transactionDisplays
  return transactionDisplaysOptions || []
}

export function overDueTypesOptions(state) {
  return state.overDueTypes.map(res => {
    return {...res, label: i18n.t('getters.overDueTypesOptions')[res.value]}
  })
}

export function loanTypesOptions(state) {
  return state.loanTypes.map(res => {
    return {...res, label: `${res.id}. ${i18n.t('getters.loanTypesOptions')[res.value]}`}
  })
}

export function restructuringTypesOptions(state) {
  return state.restructuringTypes.map(res => {
    return {...res, label: `${res.id}. ${res.label}`}
  })
}

export function hierarchysOptions(state) {
  return state.hierarchys
}

export function paymentRoundTypesOptions(state) {
  return state.paymentRoundTypes.map(res => {
    return {...res, label: i18n.t('getters.paymentRoundTypesOptions')[res.value]}
  })
}

export function loanDetailTypesOptions(state) {
  return state.loanDetailTypes.map(res => {
    return {...res, label: i18n.t('getters.loanDetailTypesOptions')[res.value]}
  })
}

export function interestTypesOptions(state) {
  return state.interestTypes.map(res => {
    return {...res, label: i18n.t('getters.interestTypesOptions')[res.value]}
  })
}

export function debtCollectionFeeTypesOptions(state) {
  return state.debtCollectionFeeTypes.map(res => {
    return {...res, label: i18n.t('getters.debtCollectionFeeTypesOptions')[res.value]}
  })
}

export function curriculumPeriodsOptions(state) {
  return state.curriculumPeriods.map(res => {
    return {...res, label: i18n.t('getters.curriculumPeriods', {value: res.value})}
  })
}

export function contractPeriodsOptions(state) {
  return state.contractPeriods.map(res => {
    return {...res, label: i18n.t('getters.contractPeriods', {year: res.value, period: res.value * 12})}
  })
}

export function periodsOptions(state) {
  const periods = state.periods
    .filter(res => res.status === IStatus.enabled)
    .map(res => {
      return {
        label: (res.name.length === 0 ? i18n.t('general.null') : res.nameTh),
        value: res.id,
        isChoose: res.isChoose
      }
    })
  return periods || []
}

export function degreeOptions(state) {
  const degrees = state.degreeOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, nameTh, isChoose}) => {
      return {
        label: (nameTh.length === 0 ? i18n.t('general.null') : `${nameTh}`),
        value: id,
        isChoose,
        id,
      }
    })
  return degrees || []
}

export function reportTypesOptions(state) {
  return state.reportTypes.map(res => {
    return {...res, label: res.label}
  })
}

export function reportTypesExecutiveOptions(state) {
  return state.reportTypesExecutive.map(res => {
    return {...res, label: res.label}
  })
}

export function projectOptions(state) {
  const projects = state.projectOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, projectNo, nameTh, isChoose}) => {
      return {
        label: (nameTh.length === 0 ? i18n.t('general.null') : `${projectNo} : ${nameTh}`),
        value: id,
        isChoose,
        id,
        projectNo,
        nameTh
      }
    })

  return projects || []
}

export function campusOptions(state) {
  const campuses = state.campusOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, nameTh, isChoose, projectId}) => {
      return {
        label: (nameTh.length === 0 ? i18n.t('general.null') : `${nameTh}`),
        value: id,
        isChoose,
        id,
        projectId,
      }
    })

  return campuses || []
}

export function facultiesOptions(state) {
  const faculties = state.faculties
    .filter(res => res.status === IStatus.enabled)
    .map(res => {
      return {
        label: (res.nameTh.length === 0 ? i18n.t('general.null') : res.nameTh),
        value: res.id,
        isChoose: res.isChoose
      }
    })
  return faculties || []
}

export function curriculumsOptions(state) {
  const curriculums = state.curriculums
    .filter(res => res.status === IStatus.enabled)
    .map(res => {
      return {
        label: (res.nameTh.length === 0 ? i18n.t('general.null') : res.nameTh),
        value: res.id,
        isChoose: res.isChoose
      }
    })
  return curriculums || []
}

export function curriculumExternalsOptions(state) {
  const curriculumExternals = state.curriculumExternals
    .filter(res => res.status === IStatus.enabled)
    .map(res => {
      return {
        label: (res.curriculumName.length === 0 ? i18n.t('general.null') : res.nameTh),
        value: res.id,
        isChoose: res.isChoose
      }
    })
  return curriculumExternals || []
}

export function facultyCurriculumOptions(state) {
  const curriculums = [...state.curriculumsOptions]
  return curriculums.sort((a, b) => {
    if (a.curriculumNo < b.curriculumNo) return -1
    if (a.curriculumNo > b.curriculumNo) return 1;
    return 0;
  })
    .filter(res => res.status === IStatus.enabled)
    .map(({id, isChoose, curriculumNo, nameTh, faculty}) => {
      let name = ""
      if (nameTh.length === 0) {
        name = i18n.t('general.null')
      } else {
        let {nameTh: facultyName,} = faculty;
        name = `${curriculumNo} : ${facultyName}/${nameTh}`
      }
      return {
        label: name,
        value: id,
        isChoose,
        id,
        curriculumNo,
        nameTh,
        faculty
      }
    })
}

export function sourcesOptions(state) {
  const sources = state.sources
    .filter(res => res.status === IStatus.enabled)
    .map(res => {
      return {label: (res.name.length === 0 ? i18n.t('general.null') : res.name), value: res.id, isChoose: res.isChoose}
    })
  return sources || []
}

export function prefixOptions(state) {
  return state.prefixOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, nameTh, isChoose}) => {
      return {
        label: (nameTh.length === 0 ? i18n.t('general.null') : `${nameTh}`),
        value: id,
        id,
        isChoose,
      }
    })
}

export function relationshipOptions(state) {
  const relationships = state.relationshipOptions
    .filter(res => res.status === IStatus.enabled)
    .map(res => {
      return {
        label: (res.nameTh.length === 0 ? i18n.t('general.null') : res.nameTh),
        value: res.id,
        isChoose: res.isChoose
      }
    })
  return relationships || []
}

export function nationalitiesOptions(state) {
  const nationalities = state.nationalities
    .filter(res => res.status === IStatus.enabled)
    .map(res => {
      return {
        label: (res.nameTh.length === 0 ? i18n.t('general.null') : res.nameTh),
        value: res.id,
        isChoose: res.isChoose
      }
    })
  return nationalities || []
}

export function racesOptions(state) {
  return state.races
    .filter(res => res.status === IStatus.enabled)
    .map(res => {
      return {
        label: (res.nameTh.length === 0 ? i18n.t('general.null') : res.nameTh),
        value: res.id,
        isChoose: res.isChoose
      }
    })
}

export function religionsOptions(state) {
  const religions = state.religions
    .filter(res => res.status === IStatus.enabled)
    .map(res => {
      return {
        label: (res.nameTh.length === 0 ? i18n.t('general.null') : res.nameTh),
        value: res.id,
        isChoose: res.isChoose
      }
    })
  return religions || []
}

export function occupationsOptions(state) {
  const occupations = state.occupations
    .filter(res => res.status === IStatus.enabled)
    .map(res => {
      return {
        label: (res.nameTh.length === 0 ? i18n.t('general.null') : res.nameTh),
        value: res.id,
        isChoose: res.isChoose
      }
    })
  return occupations || []
}

export function lendersOptions(state) {
  return state.signers
    .filter(res => res.status === IStatus.enabled && res.type === "Lender")
    .map(res => {
      let prefix = ""
      if (res.prefix) {
        prefix = res.prefix.nameTh
      }
      return {label: prefix + res.name + " " + res.surname, value: res.id}
    })
}

export function witnessesOptions(state) {
  return state.signers
    .filter(res => res.status === IStatus.enabled && res.type === "Witness")
    .map(res => {
      let prefix = ""
      if (res.prefix) {
        prefix = res.prefix.nameTh
      }
      return {label: prefix + res.name + " " + res.surname, value: res.id}
    })
}

export function notificationTemplateOptions(state) {
  const notificationTemplates = state.notificationTemplateOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, name, title, description, isChoose}) => {
      return {
        label: (name.length === 0 ? i18n.t('general.null') : `${name}`),
        value: id,
        isChoose,
        name,
        title,
        description,
        id,
      }
    })
  return notificationTemplates || []
}

export function importCustomerTypesOptions(state) {
  return state.importCustomerTypes
}

export function importAccountingTypesOptions(state) {
  return state.importAccountingTypes
}

export function importCustomTypesOptions(state) {
  return state.importCustomTypes
}

export function signerOptions(state) {
  const signers = state.signerOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, fullName, isChoose}) => {
      return {
        label: (fullName.length === 0 ? i18n.t('general.null') : `${fullName}`),
        value: id,
        id,
        isChoose,
      }
    })
  return signers || []
}

export function signerPositionOptions(state) {
  const signers = state.signerOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, fullName, position, isChoose}) => {
      return {
        label: (fullName.length === 0 ? i18n.t('general.null') : `${fullName} : ${position}`),
        value: id,
        id,
        isChoose,
      }
    })
  return signers || []
}

export function feeTypesOptions(state) {
  return state.feeTypes
    .filter(res => res.value !== IFeeType.debtCollectionFee)
    .map(res => {
      return {...res, label: i18n.t('getters.feeTypesOptions')[res.value]}
    })
}

export function expenseTypesOptions(state) {
  return state.expenseTypes
    .map(res => {
      return {...res, label: i18n.t('getters.expenseTypesOptions')[res.value]}
    })
}

export function notificationTypesOptions(state) {
  return state.notificationTypes
    .map(res => {
      return {...res, label: i18n.t('getters.notificationTypesOptions')[res.value]}
    })
}

export function debtRestructurePolicyOptions(state) {
  return state.debtRestructurePolicies.map(res => {
    return {
      ...res,
      label: `${res.title} (${res.effectiveDate || '-'})`
    }
  })
}

export function measureOptions(state) {
  return state.measures.map(res => {
    return {
      ...res,
      label: `${res.name}`
    }
  })
}

export function subMeasureOptions(state) {
  return state.subMeasureOptions.map((res) => {
    return {
      ...res,
      value: res.id,
      label: `${res.optionName}`
    }
  })
}

